import api from '@/services/api';
import type { SavedScenario, SimulationParams, CostBreakdown } from '../types';

const BASE = '/cost-simulator/scenarios';

async function list(): Promise<SavedScenario[]> {
  const res = await api.get<{ success: boolean; scenarios: SavedScenario[] }>(BASE);
  return res.data.scenarios;
}

async function create(
  name: string, parameters: SimulationParams, result: CostBreakdown,
  description?: string | null,
): Promise<SavedScenario> {
  const res = await api.post<{ success: boolean; scenario: SavedScenario }>(BASE, {
    name, parameters, result, description: description ?? null,
  });
  return res.data.scenario;
}

async function update(
  id: string, name: string, parameters: SimulationParams, result: CostBreakdown,
  description?: string | null,
): Promise<SavedScenario> {
  const body: Record<string, unknown> = { name, parameters, result };
  /* Only include `description` in the PUT body when the caller passes it
     explicitly. The backend's `description_provided` sentinel uses key
     presence to distinguish "leave unchanged" from "clear to null". */
  if (description !== undefined) body.description = description;
  const res = await api.put<{ success: boolean; scenario: SavedScenario }>(`${BASE}/${id}`, body);
  return res.data.scenario;
}

/** Metadata-only patch — used by the library modal for inline edits. */
async function updateMeta(id: string, name: string, description: string | null): Promise<SavedScenario> {
  const res = await api.put<{ success: boolean; scenario: SavedScenario }>(`${BASE}/${id}`, {
    name, description,
  });
  return res.data.scenario;
}

async function remove(id: string): Promise<void> {
  await api.delete(`${BASE}/${id}`);
}

export const scenarioService = { list, create, update, updateMeta, remove };
